import React from 'react';
import ProcedureTab from './ProcedureTab';
import { PROCEDURE_CATEGORIES } from '../../types/ProcedureTypes';

interface WallwashTabProps {
    procedures: any[];
    loading: boolean;
    error: string | null;
    selectedProcedure: any;
    setSelectedProcedure: (procedure: any) => void;
    onRefresh?: () => void;
}

const WallwashTab: React.FC<WallwashTabProps> = (props) => {
    const config = {
        title: 'Wallwash Procedures',
        description: 'Tank wallwash procedures and cleaning methods',
        icon: 'fa-spray-can',
        category: PROCEDURE_CATEGORIES.WALLWASH,
        columns: [
            {
                key: 'title',
                header: 'Title',
            },
        ],
    };

    return <ProcedureTab config={config} {...props} />;
};

export default WallwashTab;
